import React, { useState, useEffect } from "react";
import "./TestimonialCarousel.css";
import leftArrow from "../../assets/utility_images/arrow-prev-active.svg";
import leftArrowDisabled from "../../assets/utility_images/left.svg";
import rightArrow from "../../assets/utility_images/right.svg";
import rightArrowDisabled from "../../assets/utility_images/arrow-next-disabled.svg";
import Slider from "react-slick";

// Custom Arrow Components
const PrevArrow = ({ onClick, isDisabled }) => (
  <div
    className={`slick-prev custom-arrow ${isDisabled ? "disabledprev" : ""}`}
    onClick={!isDisabled ? onClick : null}
  >
    <img
      src={isDisabled ? leftArrowDisabled : leftArrow}
      alt={isDisabled ? "Prev Disabled" : "Prev"}
      loading="lazy"
    />
  </div>
);

const NextArrow = ({ onClick, isDisabled }) => (
  <div
    className={`slick-next custom-arrow ${isDisabled ? "disablednext" : ""}`}
    onClick={!isDisabled ? onClick : null}
  >
    <img
      src={isDisabled ? rightArrowDisabled : rightArrow}
      alt={isDisabled ? "Next Disabled" : "Next"}
      loading="lazy"
    />
  </div>
);

const TestimonialCarousel = ({ testimonials }) => {
  const [slidesToShow, setSlidesToShow] = useState(2);
  const [slidesToScroll, setSlidesToScroll] = useState(2);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isNextDisabled, setIsNextDisabled] = useState(false);
  const [isPrevDisabled, setIsPrevDisabled] = useState(true);

  // Handle responsiveness for the number of slides shown
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1024) {
        setSlidesToShow(1);
        setSlidesToScroll(1);
      } else {
        setSlidesToShow(2);
        setSlidesToScroll(2);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const enabledTestimonials = testimonials
    .filter((testimonial) => testimonial.isEnabled) // Only include enabled testimonials
    .sort((a, b) => a.order - b.order); // Sort by order

  const totalSlides = Math.ceil(enabledTestimonials.length / slidesToShow);

  // Handle arrow disabling logic
  const handleBeforeChange = (oldIndex, newIndex) => {
    setCurrentSlide(newIndex);
    setIsPrevDisabled(newIndex === 0);
    setIsNextDisabled(newIndex >= totalSlides - 1);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll,
    prevArrow: <PrevArrow isDisabled={isPrevDisabled} />,
    nextArrow: <NextArrow isDisabled={isNextDisabled} />,
    beforeChange: handleBeforeChange,
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
        {enabledTestimonials.map((testimonial, index) => (
          <div
            key={index}
            className={`slide d-flex flex-column ${
              index % 2 === 0 ? "light-bg" : "dark-bg"
            }`}
          >
            <img src={testimonial.imageUrl} alt="Quote Icon" loading="lazy" />
            <div className="testimonial-text">{testimonial.quote}</div>
            <div className="testimony-name">{testimonial.title}</div>
            <div className="company">{testimonial.companyOrAuthor}</div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialCarousel;
